module.exports = __webpack_public_path__ + "header-profile-skin-1.85efa900c0fc12fee15a.png";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/css/patterns/header-profile-skin-1.png
// module id = ../../../../../ng-src/assets/css/patterns/header-profile-skin-1.png
// module chunks = styles